import { CSSObject, styled, FormLabel as FormLabelBase, formLabelClasses } from '@mui/material'

export const RadioFormLabel = styled(FormLabelBase)<{ required?: boolean }>(({ theme, required }) => ({
  display: 'block',
  ...(theme.typography['Lato Body 1'] as CSSObject),
  color: theme.palette.grey[800],
  marginBottom: theme.spacing(2),

  [`& .${formLabelClasses.asterisk}`]: {
    display: 'none',
  },

  '&.Mui-error': {
    color: theme.palette.error[500],
  },

  '&.Mui-focused:not(.Mui-error)': {
    color: theme.palette.grey[800],
  },

  '&::before': {
    content: required ? "'*'" : undefined,
    color: theme.palette.error[500],
  },
}))
